import { SiteList } from 'app/modules/site-management/site-list/components/SiteList/SiteList';

export const SiteListPage = (): JSX.Element => <SiteList />;
